"use strict";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const PARALLAX_Y_PERCENT = -10;
const RESIZE_DEBOUNCE_DELAY = 200;
let animations = [];
let resizeTimer;
let windowWidth = window.innerWidth;

const getParallaxY = (item) => {
      const parallax = item.dataset.parallax;
      const value = Number(parallax);
      const ratio = parallax !== undefined && parallax.trim() !== '' && Number.isFinite(value) ? value : 1;

      return PARALLAX_Y_PERCENT * ratio;
};

const setFadeIn = (item, options = {}) => {
      const tweenVars = {
            opacity: 1,
            duration: 1.2,
            ease: 'power2.out',
            scrollTrigger: {
                  trigger: item,
                  start: 'top 70%',
                  toggleActions: 'play none none reverse'
            }
      };

      if (options.withY) {
            tweenVars.yPercent = 0;
      }

      return gsap.to(item, tweenVars);
};

const addAnimation = (animation) => {
      animations.push(animation);
};

const clearAnimations = () => {
      animations.forEach((animation) => {
            if (animation.scrollTrigger) {
                  animation.scrollTrigger.kill();
            }

            animation.kill();
      });

      animations = [];
};

const initGsap = () => {
      clearAnimations();

      gsap.utils.toArray('.js-gsap-fade:not(.js-gsap-parallax)').forEach((item) => {
            addAnimation(setFadeIn(item, {
                  withY: true
            }));
      });

      gsap.utils.toArray('.js-gsap-parallax').forEach((item) => {
            addAnimation(setFadeIn(item));

            addAnimation(gsap.to(item, {
                  yPercent: getParallaxY(item),
                  ease: 'none',
                  scrollTrigger: {
                        trigger: item,
                        start: 'top bottom',
                        end: 'bottom top',
                        scrub: true
                  }
            }));
      });
};

window.addEventListener("load", () => {
      gsap.registerPlugin(ScrollTrigger);
      ScrollTrigger.config({
            ignoreMobileResize: true
      });
      initGsap();

      window.addEventListener('resize', () => {
            if (window.innerWidth === windowWidth) {
                  return;
            }

            windowWidth = window.innerWidth;
            clearTimeout(resizeTimer);

            resizeTimer = setTimeout(() => {
                  initGsap();
                  ScrollTrigger.refresh();
            }, RESIZE_DEBOUNCE_DELAY);
      });
});
